import { TextFieldState } from '@sas-dvr/internal-va-react-core/store/birdElement/textFieldState';
import { ReportState, rootReducer } from '@sas-dvr/internal-va-react-core/store/rootReducer';
import { action, AnyAction } from '@sas/nova-commons/action';
import { applyMiddleware, createStore } from 'redux';
import { ReportStore } from '../internal/ReportContext';
import { requestIdleCallback, cancelIdleCallback } from './requestIdleCallback';

const ApplyNewState = 'delayedState/ApplyNewState';
const applyNewStateAction = (state: ReportState) => action(ApplyNewState, state);

export function getDelayedStore(store: ReportStore) {
  let idleCallbackId: number;
  const delayedStore = createStore(
    (state: ReportState | undefined, action: AnyAction) => {
      if (action.type === ApplyNewState) {
        return action.payload;
      }
      // get initial state from the parent store
      const newState = state || store.getState();
      // FIXME: BirdTextState is not batch/concurrent safe and commitValue needs to be applied before RxJS processes this action.
      if (action.type === TextFieldState.actionTypes.commitValue) {
        return rootReducer(newState, action);
      }
      return newState;
    },
    applyMiddleware((_) => (next) => (action: AnyAction) => {
      if (action.type === ApplyNewState) {
        return next(action);
      }
      const result = next(action);
      store.dispatch(action);
      return result;
    })
  );
  // Subscribe to the parent store and delay update to delayedStore
  store.subscribe(() => {
    cancelIdleCallback(idleCallbackId);
    const newState = store.getState();
    const delayedState = delayedStore.getState();

    // FIXME: setOpen needs to be applied immediately or the focus timeout will break
    //   Try  to do this in a way that doesn't force an update on first render
    const newHasOpen = Object.values(newState.birdElements.PromptContainer).some(
      (val) => val?.isOpen === true
    );
    const newDelayedOpen = Object.values(delayedState.birdElements.PromptContainer).some(
      (val) => val?.isOpen === true
    );
    // bird layout update already debounces
    if (
      newState.ui.birdLayout !== delayedState.ui.birdLayout ||
      ((newHasOpen || newDelayedOpen) && newHasOpen !== newDelayedOpen)
    ) {
      delayedStore.dispatch(applyNewStateAction(newState));
      return;
    }
    idleCallbackId = requestIdleCallback(() => {
      delayedStore.dispatch(applyNewStateAction(newState));
    });
  });
  return {
    delayedStore,
    store,
  };
}
